import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { label: "Platform", href: "/#platform" },
  { label: "Load Board", href: "/loads" },
  { label: "Pricing", href: "/pricing" },
  { label: "Solutions", href: "/#solutions" },
  { label: "Start a Company", href: "/#startup" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = ({ onQuote }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isLink = (href) => href.startsWith("/loads") || href.startsWith("/portal") || href.startsWith("/pricing");

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <img src="/cel-horizontal.png" alt="Coastal Expedited Logistics" className="h-9 lg:h-11 w-auto transition-transform duration-300 group-hover:scale-[1.03]" />
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {NAV.map((n) =>
            isLink(n.href) ? (
              <Link
                key={n.label}
                to={n.href}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-[#94A3B8] hover:text-[#2563EB] transition-colors"
              >
                {n.label}
              </Link>
            ) : (
              <a
                key={n.label}
                href={n.href}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-[#94A3B8] hover:text-[#2563EB] transition-colors"
              >
                {n.label}
              </a>
            )
          )}
          <button
            data-testid="nav-quote-btn"
            onClick={onQuote}
            className="px-5 py-2.5 rounded-full bg-[#2563EB] text-white text-sm font-semibold hover:bg-[#1D4ED8] transition-colors"
          >
            Get a Quote
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden glass border-t border-white/10 px-5 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-[#94A3B8] hover:text-[#2563EB] transition-colors"
            >
              {n.label}
            </a>
          ))}
          <button
            data-testid="nav-quote-btn-mobile"
            onClick={() => {
              setOpen(false);
              onQuote && onQuote();
            }}
            className="px-5 py-3 rounded-full bg-[#2563EB] text-white font-semibold"
          >
            Get a Quote
          </button>
        </div>
      )}
    </header>
  );
};
